const faqItems = [
  {
    id: 1,
    q: '樱花动漫之家是什么类型的平台？',
    a: '樱花动漫之家是一个专注于日本漫画资源聚合与推荐的平台，我们汇集了海量日漫资源信息，涵盖最新连载、经典名作、热门排行以及编辑精选推荐，帮助日漫爱好者发现更多好看的日本漫画。',
  },
  {
    id: 2,
    q: '如何找到适合自己的日漫推荐？',
    a: '你可以通过首页的热门排行了解当前最受关注的日漫作品，也可以在焦点专题中查看编辑团队按主题整理的精选合集。话题热榜能让你看到漫友圈正在热议的作品，评论区也有大量真实读者的分享和安利。',
  },
  {
    id: 3,
    q: '平台上的日漫更新速度如何？',
    a: '我们的编辑团队每日追踪日本漫画的最新连载动态，确保热门作品的更新信息在第一时间同步。目前平台每日更新超过200个章节信息，涵盖少年Jump、Magazine、Sunday等主流漫画杂志的最新连载。',
  },
  {
    id: 4,
    q: '樱花动漫之家的排行是如何产生的？',
    a: '热门排行综合了作品热度、读者讨论量、社区评分和编辑评价等多个维度，每周更新一次。我们力求榜单能真实反映当下日漫爱好者的关注焦点，而非单纯依赖某一指标。',
  },
  {
    id: 5,
    q: '我可以投稿或推荐自己喜爱的日漫吗？',
    a: '当然可以！我们非常欢迎漫友的投稿和推荐。你可以通过页面底部的联系方式向我们提交你心目中的佳作推荐，编辑团队会认真阅读每一份投稿，优质推荐将有机会登上平台推荐位分享给更多漫友。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            帮助中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-50 rounded-xl border border-background-200/70" open>
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="font-heading text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}